///////////////////////////////////////////////////////////////////
// Interstitial load next ad to display (loaded)

export const AD_SLOT_INTERSTITIAL_LOAD_NEXT = 'AD_SLOT_INTERSTITIAL_LOAD_NEXT';
export interface AdSlotInterstitialLoadNextAction {
    readonly type: typeof AD_SLOT_INTERSTITIAL_LOAD_NEXT;
    readonly slotId: string;
    readonly retryCount: number;
}

export const adSlotInterstitialLoadNext = (slotId: string, retryCount: number = 0): AdSlotInterstitialLoadNextAction => ({
    type: AD_SLOT_INTERSTITIAL_LOAD_NEXT, slotId, retryCount,
});

///////////////////////////////////////////////////////////////////
// Interstitial prepared to display (loaded)

export const AD_SLOT_INTERSTITIAL_PREPARED = 'AD_SLOT_INTERSTITIAL_PREPARED';
export interface AdSlotInterstitialPreparedAction {
    readonly type: typeof AD_SLOT_INTERSTITIAL_PREPARED;
}

export const adSlotInterstitialPrepared = (): AdSlotInterstitialPreparedAction => ({
    type: AD_SLOT_INTERSTITIAL_PREPARED,
});

///////////////////////////////////////////////////////////////////
// Interstitial was displayed (consumed)

export const AD_SLOT_INTERSTITIAL_CONSUMED = 'AD_SLOT_INTERSTITIAL_CONSUMED';
export interface AdSlotInterstitialConsumedAction {
    readonly type: typeof AD_SLOT_INTERSTITIAL_CONSUMED;
}

export const adSlotInterstitialConsumned = (): AdSlotInterstitialConsumedAction => ({
    type: AD_SLOT_INTERSTITIAL_CONSUMED,
});
